import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Correct from "../../images/Correct.svg";
import Incorrect from "../../images/Incorrect.svg";
import styles from "./styles";

import "animate.css/animate.css";

const FirstModal = ({
  classes,
  nextQuestion,
  handleClose,
  answeredCorrectly,
  question,
  isOpen
}) => {
  return (
    <Modal open={isOpen}
    className="animate__animated animate__fadeInRight"
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          {/* <Typography className={classes.stepNumber}>########</Typography> */}
           {/* <Typography className={classes.stepNumber}>STEP 1</Typography> */}
          <Typography className={classes.mainLine}>Pawnee’s unemployment rate is through the roof, and it’s your job to figure out why!</Typography>
          <Typography className={classes.evalDesc}>
            <ul className={classes.evalList}>
              <li className={classes.subMainLine} style={{ lineHeight:  1.2 }}>Someone is <b>cyclically unemployed</b> if their unemployment is the result of an economic downturn, i.e. a recession.</li>
              <li className={classes.subMainLine} style={{ lineHeight:  1.2 }}>Someone is <b>frictionally unemployed</b> if their unemployment is the result of a mismatch between employer and employee. Frictional unemployment is typically short-term, and these individuals will be likely to land a new job soon!</li>
              <li className={classes.subMainLine} style={{ lineHeight:  1.2 }}>Someone is <b>structurally unemployed</b> if their job or skillset is no longer in demand due to large shocks or shifts in the economy that make particular jobs or skill sets obsolete or uncompetitive.</li>
            </ul>
          </Typography>
          <Grid container justify="center" className={classes.submitButtonDiv}>
            <Button className={classes.submitButton} onClick={handleClose}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(FirstModal);
